module.exports = __webpack_public_path__ + "img/jellybean_silverado.5c7260cc.png";